var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill circle-checked",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM19.6689 9.71387L13.499 18.2686C13.4128 18.3889 13.2991 18.487 13.1674 18.5546C13.0357 18.6223 12.8898 18.6576 12.7417 18.6576C12.5936 18.6576 12.4477 18.6223 12.316 18.5546C12.1843 18.487 12.0706 18.3889 11.9844 18.2686L8.33105 13.2061C8.21973 13.0508 8.33105 12.834 8.52148 12.834H9.89551C10.1943 12.834 10.4785 12.9775 10.6543 13.2236L12.7402 16.1182L17.3457 9.73145C17.5215 9.48828 17.8027 9.3418 18.1045 9.3418H19.4785C19.6689 9.3418 19.7803 9.55859 19.6689 9.71387Z",
    fill: "#276580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/circle-checked.44312fc9c3fe35376ea3fb6f4071c7cc.svg";
export { ForwardRef as ReactComponent };